import { render, staticRenderFns } from "./GkfxIndex.vue?vue&type=template&id=56cd1765&scoped=true&"
import script from "./GkfxIndex.vue?vue&type=script&lang=js&"
export * from "./GkfxIndex.vue?vue&type=script&lang=js&"
import style0 from "./GkfxIndex.vue?vue&type=style&index=0&id=56cd1765&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56cd1765",
  null
  
)

export default component.exports